import { FaFileAlt, FaFileAudio, FaFileImage, FaFileVideo } from 'react-icons/fa';

export const getMimeTypeIcon = (mimeType: string, size: number = 50) => {
  const iconMap: { [key: string]: JSX.Element } = {
    'image/jpeg': <FaFileImage size={size} />,
    'image/png': <FaFileImage size={size} />,
    'image/gif': <FaFileImage size={size} />,
    'image/webp': <FaFileImage size={size} />,
    'image/bmp': <FaFileImage size={size} />,
    'image/svg+xml': <FaFileImage size={size} />,

    'video/mp4': <FaFileVideo size={size} />,
    'video/webm': <FaFileVideo size={size} />,
    'video/ogg': <FaFileVideo size={size} />,
    'video/x-msvideo': <FaFileVideo size={size} />,

    'audio/mpeg': <FaFileAudio size={size} />,
    'audio/ogg': <FaFileAudio size={size} />,
    'audio/wav': <FaFileAudio size={size} />,
  };

  return iconMap[mimeType] || <FaFileAlt size={size} />;
};
